const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaFronteira: [],
	listaOperacao: [],
	listaCidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LAUDO_OFICINA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LAUDO_OFICINA_FRONTEIRA_SELECT_LISTADO':
            return { ...state,
				listaFronteira: action.payload.data
			};
		
		case 'LAUDO_OFICINA_OPERACAO_SELECT_LISTADO':
			return { ...state,
				listaOperacao: action.payload.data
			};
		
		case 'LAUDO_OFICINA_CIDADE_SELECT_LISTADO':
			return { ...state,
				listaCidade: action.payload.data
			};

        case 'LAUDO_OFICINA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
